import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  userService,
  vmSharedModelService,
} from 'app/services';
import {
  alerts,
  confirmDialog
} from 'app/components/global';
import editVendorDialog from '../dialog.editVendorDialog';
import controller from './vendor.controller';
import directive from './vendor.directive';


export default angular.module('app.components.advisory.bcp.vendor', [
  alerts,
  confirmDialog,
  loaderService,
  ssDialogService,
  userService,
  vmSharedModelService,
  editVendorDialog,
])
  .directive('bcpVendor', directive)
  .controller('bcp.VendorController', controller)
  .name;

console.log('app.components.advisory.bcp.vendor created');
